import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { PermissionCheck } from "../../shared/permission";
import { AssignmentFilter } from "../../models/assignment-filter.model";
import { FiltersDialogController } from "./filters-dialog.component";

let AssignmentFiltersDialogComponent = {
    selector: "vcAssignmentFiltersDialog",
    templateUrl:
        "/angular/components/planner/assignment-filters.component.html",
    bindings: {
        filters: "=?",
    },
    controller: class AssignmentFiltersDialogController extends FiltersDialogController {
        // * bindings for typescript compiler *
        public filters: AssignmentFilter;
        // ************************************
        private $scope: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        public customTemplates: any;
        public permissionProvider: PermissionCheck;
        public showStatus: boolean = false;

        constructor(
            $scope: any,
            $timeout: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            PermissionCheck: PermissionCheck
        ) {
            super($timeout);
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.permissionProvider = PermissionCheck;
        }

        $onInit() {
            this.customTemplates = this.filters.getCustomDateTemplates();
        }

        openUsersTeamsDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-widget-filter-users-teams-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: false,
                    ariaLabel: "Users or Teams Filter",
                    size: "med",
                    locals: {
                        filter: angular.copy(this.filters),
                        allowUnassigned: true,
                        defaultTab: "user",
                    },
                })
                .then((filters: any): void => {
                    this.filters.setData(filters);
                });
        }

        filterUnassigned(): void {
            this.filters.users = [null];
        }

        toggleStatus(): void {
            this.showStatus = !this.showStatus;
        }

        selectStatus(status: string): void {
            if (!this.filters.status) {
                this.filters.status = [];
            }
            let index = this.filters.status.indexOf(status);
            if (index > -1) {
                this.filters.status.splice(index, 1);
            } else {
                this.filters.status.push(status);
            }
        }

        clear(): void {
            this.filters.reset();
        }
        cancel(): void {
            this.dialog.cancel();
        }

        save(): void {
            this.dialog.hide(this.filters);
        }
    },
};

angular
    .module("planner")
    .component(
        AssignmentFiltersDialogComponent.selector,
        AssignmentFiltersDialogComponent
    );
